import ButtonEditor from '@intercom/embercom-composer/components/button-editor';
export default ButtonEditor;
